import { DayPickerInputLocaleUtils as localUtils } from "lib/luxonLocaleUtils";
import onPhoneMask from "utils/onPhoneMask";

function isUndefined(o) {
    return typeof o === "undefined";
}

const onToggleDropdown = (event) => {
    const calcHeight = () => {
        const newHeight = cont.getBoundingClientRect().height;

        drop.style.maxHeight = `${newHeight}px`;
    };

    const dropBlock = event.target.closest(".dropdown-block");

    const drop = dropBlock.querySelector(".dropdown");
    const cont = dropBlock.querySelector(".dropdown-content");

    // drop.style.setProperty('--mh', `${cont.getBoundingClientRect().height}px`);

    calcHeight();

    window.addEventListener("resize", calcHeight);
};

const stickyHeader = (selector) => {
    const el = document.querySelector(selector);

    function watchHeader() {
        if (window.pageYOffset > el.clientHeight) {
            if (!el.classList.contains("fixed")) {
                el.classList.add("fixed");
            }
        } else {
            el.classList.remove("fixed");
        }
    }

    document.addEventListener("scroll", watchHeader);
};

const animateCSS = (node, animation, prefix = "animate__") =>
    // We create a Promise and return it
    new Promise((resolve) => {
        const animationName = `${prefix}${animation}`;
        //const node = document.querySelector(element);

        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd() {
            node.classList.remove(`${prefix}animated`, animationName);
            node.removeEventListener("animationend", handleAnimationEnd);

            resolve("Animation ended");
        }

        node.addEventListener("animationend", handleAnimationEnd);
    });

function getCurrentDomain() {
    const domainZone = document.location.hostname
        .split(".")
        .slice(-1)
        .join(".");

    if (domainZone.match(/^\d+$/)) {
        return document.location.hostname;
    }

    return document.location.hostname.split(".").slice(1).join(".");
}

/**
 * Собирает набо классов из имени элемента/блока и модификаторов
 *
 * @param {string} name - название блока или элемента
 * @param {string[]} modificators - массив модификаторов
 */
function BEMClasses(name, modificators=[]) {
    return [name, ...modificators.map((mod) => `${name}_${mod}`)].join(" ");
}

//TODO: почему-то при импорте отсюда не работает нормально приложение. Это надо поправить
export {
    isUndefined,
    onToggleDropdown,
    stickyHeader,
    onPhoneMask,
    animateCSS,
    localUtils,
    getCurrentDomain,
    BEMClasses,
};
